export default __webpack_public_path__ + "static/media/hero.d17a0cca.png";